var BranchLaboratoryEnum = /* @__PURE__ */ ((BranchLaboratoryEnum2) => {
  BranchLaboratoryEnum2["BRANCH_LABORATORY_REDIRECT_MODAL_TITLE"] = "branch-laboratory-redirect-modal--title";
  BranchLaboratoryEnum2["BRANCH_LABORATORY_REDIRECT_MODAL_CLOSE_BUTTON"] = "branch-laboratory-redirect-modal--close-button";
  BranchLaboratoryEnum2["BRANCH_LABORATORY_REDIRECT_MODAL_TEXT"] = "branch-laboratory-redirect-modal--text";
  BranchLaboratoryEnum2["BRANCH_LABORATORY_REDIRECT_MODAL_LINK_REDIRECT"] = "branch-laboratory-redirect-modal--link-redirect";
  BranchLaboratoryEnum2["BRANCH_LABORATORY_PROFILE_EXAMS_BUTTON"] = "branch-laboratory-profile--exams-button";
  return BranchLaboratoryEnum2;
})(BranchLaboratoryEnum || {});
export {
  BranchLaboratoryEnum
};
